import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import axiosInterceptor from '../function/axiosInterceptor';
function Login() {
    const navigate = useNavigate();
    const [data, setData] = useState({ username: '', password: '' })
    const changeInput = (event) => {
        const target = event.currentTarget;
        setData((prev) => ({ ...prev, [target.name]: target.value }))
    }
    const login = async (e) => {
        e.preventDefault();
        if (!data.username || !data.password) {
            toast.warn('All field required.')
        }
        try {
            const response = await axiosInterceptor.post('/login', data);
            if (response.status == 1) {
                toast.success(response.message, { position: 'top-center', autoClose: 700 })
                localStorage.setItem('mnbfoundation', response.data);
                navigate('/admin/dashboard');
                return
            }
            toast.warning(response.message, { position: 'top-center', autoClose: 700 })

        } catch (err) {
            toast.error(err.message, { position: 'top-center', autoClose: 700 })
        }
    }
    return (
        <div className="main-wrapper pt-5">
            <div className="page-wrapper full-page p-5">
                <div className="page-content d-flex align-items-center justify-content-center p-5">
                    <div className="row w-100 mx-0 auth-page">
                        <div className="col-md-7 col-xl-6 mx-auto" style={{ maxWidth: "430px" }}>
                            <div className="card">
                                <div className="row">
                                    <div className="col-md-11 ps-md-0 mx-auto">
                                        <div className="auth-form-wrapper px-4 py-5">
                                            <Link to="#" className="noble-ui-logo d-block mb-2">Mnb<span>Foundation</span></Link>
                                            <h5 className="text-muted fw-normal mb-4">Welcome to mnboundation.</h5>
                                            <form className="forms-sample" onSubmit={login}>
                                                <div className="mb-3">
                                                    <label htmlFor="username" className="form-label">Username</label>
                                                    <input type="text" className="form-control" id="username" name='username' placeholder="Email" value={data?.username} onInput={changeInput} required />
                                                </div>
                                                <div className="mb-3">
                                                    <label htmlFor="password" className="form-label">Password</label>
                                                    <input type="password" className="form-control" id="password" name='password' placeholder="Password" value={data?.password} onInput={changeInput} required />
                                                </div>
                                                <div className="form-check mb-3">
                                                    <input type="checkbox" className="form-check-input" id="authCheck" required />
                                                    <label className="form-check-label" for="authCheck">
                                                        Remember me
                                                    </label>
                                                </div>
                                                <div className="mb-3">
                                                    <input type="submit" className="btn btn-primary form-control" id="userPassword" autocomplete="current-password" value="Login" />
                                                </div>
                                                <Link to="" className="d-block mt-3 text-muted text-center">Forget Password?</Link>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Login;